import BarChartWidget from './bar-chart.widget';
export default BarChartWidget;
